import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'serviceos-ng-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class SosNavigationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
